export default function Logo() {
  return (
    <img
      src="/logo-white.png"
      alt="Smart Marketer Agency"
      className="h-7 w-auto sm:h-8"
      width="1024"
      height="207"
    />
  );
}
